import * as React from 'react';
import {CONTENT_TYPE} from '../../Config/appConfig';
import AppContainer from './AppContainer';
import {CoverNote, RecordCount} from '../../Config/dataModel';

interface ArchivedContainerProps {
    newRecord?: CoverNote,
    newCount?: RecordCount
}

class ArchivedContainer extends React.Component <ArchivedContainerProps, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.ARCHIVED} newRecord={this.props.newRecord} newCount={this.props.newCount}/>
        );
    }
}

export default ArchivedContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/ArchivedContainer.tsx